import React from "react";
import { Button, Modal, Col, Row, Input, Form } from "antd";
const { TextArea } = Input;

const WriteReviewModal = (props: {
  open: boolean;
  isReviewSubmitting: boolean;
  handleCancel: Function;
  handleSubmit: Function;
  form: any;
  setFirstName: any;
  setLastName: any;
  setEmail: any;
  setTitle: any;
  setComments: any;
}) => {
  const { open, handleCancel, isReviewSubmitting, handleSubmit, form, setFirstName, setLastName, setEmail, setTitle, setComments } = props;
  return (
    <Modal
      open={open}
      title="Write a Review"
      onCancel={() => handleCancel()}
      footer={[
        <Button
          key="back"
          onClick={() => handleCancel()}
          disabled={isReviewSubmitting}
        >
          Cancel
        </Button>,
        <Button
          key="submit"
          type="primary"
          htmlType="submit"
          loading={isReviewSubmitting}
          disabled={isReviewSubmitting}
          onClick={() => handleSubmit()}
        >
          Submit
        </Button>,
      ]}
    >
      <Form name="basic" form={form} layout="vertical">
        <Row gutter={24}>
          <Col span={12}>
            <Form.Item
              label="First Name"
              name="firstName"
              rules={[
                {
                  required: true,
                  message: "Please input your First Name!",
                },
              ]}
            >
              <Input onChange={(e: any) => setFirstName(e.target.value)}/>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Last Name"
              name="lastName"
              rules={[
                {
                  required: true,
                  message: "Please input your Last Name!",
                },
              ]}
            >
              <Input onChange={(e: any) => setLastName(e.target.value)}/>
            </Form.Item>
          </Col>
        </Row>
        <Form.Item
          label="Email"
          name="email"
          rules={[
            {
              required: true,
              message: "Please input your email!",
            },
            {
              type: "email",
              message: "Please enter a valid email address!",
            },
          ]}
        >
          <Input onChange={(e: any) => setEmail(e.target.value)}/>
        </Form.Item>
        <Form.Item
          label="Title"
          name="title"
          rules={[
            {
              required: true,
              message: "Please input a review title!",
            },
          ]}
        >
          <Input onChange={(e: any) => setTitle(e.target.value)}/>
        </Form.Item>
        <Form.Item
          label="What do you think of the property?"
          name="comments"
          rules={[
            {
              required: true,
              message: "Please provide comments!",
            },
          ]}
        >
          <TextArea rows={4} onChange={(e: any) => setComments(encodeURIComponent(e.target.value))} />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default WriteReviewModal;
